import { stopSubmit } from 'redux-form'
import { useEffect } from 'react'
import { useDispatch } from 'react-redux'

const useRecaptchaOutsideClick = (form) => {
  const dispatch = useDispatch()

  const handleOutsideCaptcha = function (e) {
    let challenge = document.querySelectorAll(
      'iframe[src*="recaptcha/api2/bframe"]',
    )

    if (challenge.length > 0 && challenge[0] !== e.target) {
      dispatch(stopSubmit(form, []))
    }
  }

  useEffect(() => {
    document.addEventListener('mouseup', handleOutsideCaptcha)

    return () => {
      document.removeEventListener('mouseup', handleOutsideCaptcha)
    }
  }, [])
}

export default useRecaptchaOutsideClick
